<template>
    <div class="message-widget-footer">
        <div class="message-input-widget-wrapper">
            <div class="message-input-widget">
                <div class="file-widget-wrapper">
                    <div v-if="isFileMessage" class="preview-file-widget">
                        <div class="image-widget" v-if="fileType === 'image'">
                            <div class="file-widget-options">
                                <h2>Photo</h2>
                                <button @click="removeFile" class="btn-remove">Remove</button>
                            </div>
                            <img class="image-preview" :src="filePreview" />
                        </div>
                        <div class="video-widget" v-if="fileType === 'video'">
                            <div class="file-widget-options">
                                <h2>Video</h2>
                                <button @click="removeFile" class="btn-remove">Remove</button>
                            </div>
                            <video class="video-preview" :src="filePreview" controls />
                        </div>
                        <div class="file-widget" v-if="fileType === 'file'">
                            <div class="document-widget">
                                <img src="@/assets/file-icon/file.svg" />
                                <h4>{{ fileName }}</h4>
                            </div>
                            <div class="file-widget-options">
                                <button @click="removeFile" class="btn-remove">&times;</button>
                            </div>
                        </div>
                        <div>
                            <progress-bar class="p-success" :value="uploadProgress"></progress-bar>
                        </div>
                    </div>
                </div>
                <textarea class="message-input" v-model="messageText" placeholder="Type Here..."
                    @keyup.enter="sendMessage"></textarea>
            </div>
            <div class="message-files-options">
                <chat-emoji-picker @select-emoji="insertEmoji" />
                <message-file-widget @file-selected="onFileSelected" @upload-progress="onUploadProgress"
                    @upload-completed="onUploadCompleted">
                    <button class="btn-photo">
                        <img src="@/assets/icons/attach-file-gray.svg" />
                    </button>
                </message-file-widget>
            </div>
        </div>
        <div class="message-option">
            <button class="btn-send" @click="sendMessage">
                <img src="@/assets/icons/send-white.svg" />
            </button>
        </div>
    </div>
</template>

<script>
import ChatEmojiPicker from './ChatEmojiPicker.vue'
import MessageFileWidget from '@/components/MessageFileWidget.vue'

export default {
    name: 'ChatInput',
    components: {
        ChatEmojiPicker,
        MessageFileWidget,
    },
    data() {
        return {
            messageText: '',
            isFileMessage: false,
            fileType: '',
            fileName: '',
            filePreview: null,
            uploadProgress: 0
        }
    },
    methods: {
        insertEmoji(emoji) {
            this.messageText += emoji
        },
        onFileSelected(data) {
            this.isFileMessage = true
            this.fileType = data.file_type
            this.fileName = data.file_name
            this.filePreview = data.file_type === 'image' ? data.image.blob :
                data.file_type === 'video' ? data.video.blob : null
            this.$emit('file-selected', data)
        },
        onUploadProgress(progress) {
            this.uploadProgress = progress[0].progress
            this.$emit('upload-progress', progress)
        },
        onUploadCompleted(data) {
            this.$emit('upload-completed', data)
        },
        removeFile() {
            this.isFileMessage = false
            this.fileType = ''
            this.fileName = ''
            this.filePreview = null
            this.uploadProgress = 0
            this.$emit('remove-file')
        },
        sendMessage() {
            if (this.messageText.trim() || this.isFileMessage) {
                this.$emit('send', {
                    text: this.messageText,
                    isFileMessage: this.isFileMessage,
                    fileType: this.fileType,
                    fileName: this.fileName
                })
                this.messageText = ''
                this.isFileMessage = false
                this.fileType = ''
                this.fileName = ''
                this.filePreview = null
                this.uploadProgress = 0
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.message-widget-footer {
    background: #ffffff;
    width: 100%;
    padding: 6px 5px 5px 6px;
    border-top: 1px solid #ededed;
    display: flex;

    .message-input-widget-wrapper {
        width: calc(100% - 35px);
        background: #fff;
        margin-right: 10px;
        border-radius: 5px;
        padding: 5px 0px;
        display: flex;
        border: 1px solid #ddd;

        .message-input-widget {
            width: 95%;

            .file-widget-wrapper {
                position: relative;

                .preview-file-widget {
                    position: absolute;
                    bottom: 5px;
                    background: #fff;
                    right: -1px;
                    left: -1px;
                    display: flex;
                    flex-direction: column;
                    padding: 10px;
                    border: 1px solid #ddd;
                    border-radius: 5px;

                    .image-widget,
                    .video-widget {
                        .file-widget-options {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding-bottom: 10px;

                            .btn-remove {
                                background: #1ba5a4;
                                border-radius: 5px;
                                font-size: 13px;
                                padding: 0px 13px;
                                color: #fff;
                                height: 40px;
                            }
                        }

                        .image-preview,
                        .video-preview {
                            width: 100%;
                        }
                    }

                    .file-widget {
                        display: flex;
                        margin-bottom: 10px;
                        justify-content: space-between;

                        .document-widget {
                            display: flex;
                            align-items: center;
                            width: 96%;

                            img {
                                margin-right: 10px;
                            }

                            h4 {
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                width: 100%;
                            }
                        }

                        .btn-remove {
                            font-size: 25px;
                        }
                    }
                }
            }

            .message-input {
                width: 100%;
                outline: none;
                resize: none;
                height: 23px;
                padding: 0px 10px;
                transition: 500ms ease-in-out;
                padding-top: 4px;

                &:focus {
                    height: 80px;
                }
            }
        }

        .message-files-options {
            display: flex;
            position: relative;
            height: 30px;

            .btn-photo {
                display: flex;
                align-items: center;
                height: 30px;

                img {
                    width: 17px;
                    object-fit: contain;
                }
            }
        }
    }

    .message-option {
        .btn-send {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 35px;
            height: 35px;
            background: #1ba5a4;
            border-radius: 5px;

            img {
                width: 20px;
            }
        }
    }
}
</style>